import { createUseStyles } from '@pushpay/styles';
import { customizeScrollBar } from '../shared-styles';
export const logoSize = '24px';
export const headerPadding = '16px';
const useStyles = createUseStyles(theme => {
  const orgItemHeight = '60px';
  return {
    root: {
      position: 'relative',
      zIndex: theme.ELEVATION.LAYOUT.Z_INDEX + 1,
      font: theme.TYPOGRAPHY.BODY_1
    },
    orgSwitcherPanel: {
      position: 'fixed',
      top: '56px',
      left: 0,
      height: 'calc(100vh - 56px)',
      backgroundColor: theme.colors['color-background-surface'],
      width: '256px',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 3px 6px, rgba(0, 0, 0, 0.38) 0px 3px 6px'
    },
    orgOverlayWrapper: {
      marginTop: theme.SPACING.XXSMALL,
      height: `calc(100% - ${orgItemHeight})`,
      backgroundColor: theme.colors['color-background-surface'],
      overflow: 'auto',
      ...customizeScrollBar(theme)
    },
    options: {
      overflowY: 'auto',
      maxHeight: '100%'
    },
    orgSummary: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '16px'
    },
    orgSummaryArrowIcon: {
      transition: 'transform 150ms ease 0s'
    },
    panelOpenIcon: {
      transform: 'rotate(-180deg)'
    }
  };
});
export default useStyles;